import Entity from './entity'
export default class outair_threshold extends Entity<number>{
}